(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-av-gallery]';

    const initialise = (root) => {
      if (!root || root.dataset.avGalleryReady === 'true') return;
      root.dataset.avGalleryReady = 'true';

      const grid = root.querySelector('[data-av-gallery-grid]');
      const cards = Array.from(root.querySelectorAll('[data-av-gallery-card]'));
      const modal = root.querySelector('[data-av-gallery-modal]');
      const image = modal?.querySelector('[data-av-gallery-modal-image]');
      const title = modal?.querySelector('[data-av-gallery-modal-title]');
      const description = modal?.querySelector('[data-av-gallery-modal-description]');
      const productLink = modal?.querySelector('[data-av-gallery-modal-product]');
      const enquireLink = modal?.querySelector('[data-av-gallery-modal-enquire]');
      const listeners = [];

      const listen = (target, eventName, handler) => {
        target?.addEventListener(eventName, handler);
        listeners.push(() => target?.removeEventListener(eventName, handler));
      };

      const layoutGrid = () => {
        if (!grid) return;
        grid.classList.add('is-masonry');
        const styles = window.getComputedStyle(grid);
        const rowHeight = Number.parseFloat(styles.gridAutoRows) || 8;
        const rowGap = Number.parseFloat(styles.rowGap) || 14;
        cards.forEach((card) => {
          card.style.gridRowEnd = 'auto';
          const height = card.getBoundingClientRect().height;
          card.style.gridRowEnd = `span ${Math.ceil((height + rowGap) / (rowHeight + rowGap))}`;
        });
      };

      let layoutFrame = 0;
      const requestLayout = () => {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(layoutGrid);
      };

      cards.forEach((card) => {
        const cardImage = card.querySelector('img');
        if (cardImage && !cardImage.complete) listen(cardImage, 'load', requestLayout);
      });

      const resizeObserver = typeof ResizeObserver === 'function' && grid
        ? new ResizeObserver(requestLayout)
        : null;
      if (resizeObserver) resizeObserver.observe(grid);
      listen(window, 'resize', requestLayout);
      requestLayout();

      root.querySelectorAll('[data-av-gallery-open]').forEach((button) => {
        listen(button, 'click', () => {
          if (!modal || typeof modal.showModal !== 'function') {
            window.location.assign(button.dataset.productUrl);
            return;
          }

          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt || button.dataset.title;
          title.textContent = button.dataset.title;
          description.textContent = button.dataset.description;
          productLink.href = button.dataset.productUrl;
          const enquiry = new URL('/pages/contact', window.location.origin);
          enquiry.searchParams.set('interest', 'Bespoke ring');
          enquiry.searchParams.set('design', `Hello AurumVitaSG, I would like to enquire about ${button.dataset.title}. Product link: ${new URL(button.dataset.productUrl, window.location.origin).href}`);
          enquireLink.href = enquiry.pathname + enquiry.search;
          document.documentElement.classList.add('av-gallery-modal-open');
          modal.showModal();
        });
      });

      listen(modal, 'close', () => {
        document.documentElement.classList.remove('av-gallery-modal-open');
        image.removeAttribute('src');
      });

      listen(modal, 'click', (event) => {
        if (event.target === modal) modal.close();
      });

      root.avGalleryCleanup = () => {
        window.cancelAnimationFrame(layoutFrame);
        resizeObserver?.disconnect();
        listeners.forEach((remove) => remove());
        if (modal?.open) modal.close();
        document.documentElement.classList.remove('av-gallery-modal-open');
        delete root.dataset.avGalleryReady;
      };
    };

    const initialiseAll = (scope = document) => scope.querySelectorAll(selector).forEach(initialise);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((root) => root.avGalleryCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
